import { supabase } from '@/lib/supabaseClient';
import type { Inquilino } from './tenantService';
import { TABLE_NAMES } from '@/lib/constants';

export interface Unidad {
  id_unidad?: string;
  id_edificio: string;
  numero_unidad: string;
  tipo_unidad?: string;
  esta_ocupada?: boolean;
  currentTenant?: Inquilino | null;
}

export const unitService = {
  async getUnitsByBuilding(buildingId: string) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.UNIDAD)
      .select('*')
      .eq('id_edificio', buildingId);
    if (error) throw error;
    return data;
  },

  async createUnit(unit: Unidad) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.UNIDAD)
      .insert([unit])
      .select();
    if (error) throw error;
    return data[0];
  },

  async updateUnit(id: string, updates: Partial<Unidad>) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.UNIDAD)
      .update(updates)
      .eq('id_unidad', id)
      .select();
    if (error) throw error;
    return data[0];
  },

  async deleteUnit(id: string) {
    const { error } = await supabase
      .from(TABLE_NAMES.UNIDAD)
      .delete()
      .eq('id_unidad', id);
    if (error) throw error;
    return true;
  },
};